import React, { Fragment, useEffect, useState } from 'react';

import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';

import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { SSDComps } from '../../../../Brands/SSD/Start'; 

export const Comps_Home = (props) => {
    return (
        <SSDComps>
            <Comps_HomeContent />
        </SSDComps>
    );
}   
export default Comps_Home;

export const Comps_HomeContent = (props) => {

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
    }, []);

    return (
        <Block name="CompsHome" isAlt={false}>

            <TextHeader
                text="Sans Souci Dolphins Competions Corner"
            />

            <TextTitle
                text="Here you will find all the info regarding the local club, state and country competitions"
            />

            <Comps_HomeInfoBlock
                title="Pucko Awards"
                info="....coming soon" />


            <Comps_HomeInfoBlock
                title="Club Species Comps"
                info="....coming soon" />


            <Comps_HomeInfoBlock
                title="USFA Competitions"
                info="....coming soon" />

            <Comps_HomeInfoBlock
                title="Club and National results"
                info="....coming soon" />

        </Block>
    );
}


export const Comps_HomeInfoBlock = (props) => {
    useEffect(() => {
    }, []);

    return (
        <Fragment>
            <Row>
                <Col>
                    <h3>{props.title}</h3>
                </Col>
            </Row>
            <Row>
                <Col>
                    {props.info}
                </Col>
            </Row>
            <Row>
                <Col>
                    <br />
                </Col>
            </Row>
        </Fragment>
    );
}
